import { Action, createReducer, on } from '@ngrx/store';
import {
    openConfirmationDialogCancelled,
    openConfirmationDialogConfirmed,
    resetDialogState
} from 'src/app/shared/actions/confirmation-dialog.actions';
import { ConfirmationDialogState } from 'src/app/shared/state/confirmation-dialog.state';

const initialState: ConfirmationDialogState = {
    result: false,
    data: undefined
};

const reducer = createReducer(
    initialState,

    on(openConfirmationDialogConfirmed, (state, action) => ({
        ...state,
        result: action.result,
        data: action?.data ?? undefined
    })),

    on(openConfirmationDialogCancelled, (state, action) => ({
        ...state,
        result: action.canceled
    })),

    on(resetDialogState, () => ({
        ...initialState
    }))
);

export function confirmationDialogReducer(state: ConfirmationDialogState | undefined, action: Action) {
    return reducer(state, action);
}
